export default __webpack_public_path__ + "static/media/sharjah-international-authority-free-zone.e87751bf.png";